import { render, staticRenderFns } from "./HipodromoFormType.vue?vue&type=template&id=213050c1&"
import script from "./HipodromoFormType.vue?vue&type=script&lang=js&"
export * from "./HipodromoFormType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports